import React from "react";

const ITEMS = [
  "RTL",
  "SAT.1",
  "PRO7",
  "VOX",
  "NDR",
  "Promi Big Brother",
  "DSDS",
  "Schlagerboom",
  "Schlagerchampions",
  "MDR",
  "ARD",
  "ZDF",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="press-marquee"
      className="relative bg-[#0A0A0A] border-y border-white/5 py-8 overflow-hidden"
    >
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10 pointer-events-none" />
      <div className="marquee-track">
        {loop.map((label, idx) => (
          <div
            key={`${label}-${idx}`}
            className="flex items-center px-10 shrink-0"
          >
            <span className="font-display italic text-lg md:text-xl text-[#A3A3A3] tracking-wide">
              {label}
            </span>
            <span className="ml-10 text-[#D4AF37]/40 text-xs">◆</span>
          </div>
        ))}
      </div>
    </section>
  );
}
